<!-- selector -->

<div class="row">
	<div class="d-flex justify-content-center">
		<app-radio
			[genericConfig]="this.specificConfig.selector"
			(radioSelected)="this.onFilterSelection($event)"></app-radio>
	</div>
</div>
<div class="row mb-4">
	@if (this.visibleFilter) {
		@switch (this.visibleFilter.type) {
			@case (filterType.MULTI_SELECT) {
				<app-multi-select
					[genericConfig]="this.visibleFilter"
					(optionChanged)="this.onSelectedFilterChange($event)"></app-multi-select>
			}
			@case (filterType.RADIO) {
				<app-radio
					[genericConfig]="this.visibleFilter"
					(radioSelected)="this.onSelectedFilterChange($event)"></app-radio>
			}
			@case (filterType.DATEPICKER) {
				<app-multi-datepicker
					[genericConfig]="this.visibleFilter"
					(dateSelected)="this.onSelectedFilterChange($event)"></app-multi-datepicker>
			}
			@case (filterType.EMPTY) {
				<app-empty></app-empty>
			}
		}
	}
</div>
